import CardShowcaseEvent from './card-showcase-event'

export default CardShowcaseEvent
